var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore
import { useEffect } from 'react';
import { usePagination, useSortBy, useTable } from "react-table";
import MaUTable from "@material-ui/core/Table";
import { TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
export default function Table(props) {
    var _a = useTable({ columns: props.columns, data: props.data }, useSortBy, usePagination), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, rows = _a.rows, prepareRow = _a.prepareRow, 
    // @ts-ignore
    page = _a.page, 
    // @ts-ignore
    canPreviousPage = _a.canPreviousPage, 
    // @ts-ignore
    canNextPage = _a.canNextPage, 
    // @ts-ignore
    pageOptions = _a.pageOptions, 
    // @ts-ignore
    pageCount = _a.pageCount, 
    // @ts-ignore
    gotoPage = _a.gotoPage, 
    // @ts-ignore
    nextPage = _a.nextPage, 
    // @ts-ignore
    previousPage = _a.previousPage, 
    // @ts-ignore
    setPageSize = _a.setPageSize, 
    // @ts-ignore
    _b = _a.state
    // @ts-ignore
    , pageIndex = _b.pageIndex, pageSize = _b.pageSize;
    useEffect(function () {
        console.log(headerGroups);
    }, [headerGroups]);
    return (_jsx(_Fragment, { children: _jsxs(MaUTable, __assign({}, getTableProps(), { children: [_jsx(TableHead, { children: headerGroups.map(function (headerGroup) { return (_jsx(TableRow, __assign({}, headerGroup.getHeaderGroupProps(), { children: headerGroup.headers.map(function (column) { return (_jsxs(TableCell, __assign({}, column.getHeaderProps(column.getSortByToggleProps()), { style: props.alignHeaders ? {
                                borderBottom: 'solid 3px black',
                                color: 'black',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                textAlign: props.alignHeaders
                            } :
                                {
                                    borderBottom: 'solid 3px black',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                }, className: 'react-table-cells' }, { children: [column.render('Header'), _jsx("span", { children: column.isSorted ? column.isSortedDesc ? ' ▼' : ' ▲' : '' }, void 0)] }), void 0)); }) }), void 0)); }) }, void 0), _jsx(TableBody, __assign({}, getTableBodyProps(), { children: rows.map(function (row) {
                        prepareRow(row);
                        return (_jsx(TableRow, __assign({}, row.getRowProps(), { children: row.cells.map(function (cell) {
                                return (_jsx(TableCell, __assign({}, cell.getCellProps(), { style: {
                                        padding: '10px',
                                    } }, { children: cell.render('Cell') }), void 0));
                            }) }), void 0));
                    }) }), void 0)] }), void 0) }, void 0));
}
